export const TICKET_TOKEN_ADDRESS = "0x5D4353359399aB2598E67Ef7081CB2E58A49931B";
export const DONATION_FUND_TOKEN_ADDRESS = "0xb90fBc5bB5bb1db53471671729b699CD19C133a7";
export const GIVING_FUND_ADDRESS = "0xDC31683Ac5742Ea9872aD094390B7B9F31B86E7a";

// export const TICKET_TOKEN_ADDRESS = "0xcD7944154CBA710e4044733b16eC6B5F4F2C742e";
// export const DONATION_FUND_TOKEN_ADDRESS = "0x7E7C4327aB4A30E92C2f5069762c52C529701ecc";
// export const GIVING_FUND_ADDRESS = "0x702a3fefe8B324e7Be41911be25Dde714077f1d9";

// export const TICKET_TOKEN_ADDRESS = "0xB232ecF8474C15f03B2d3D65D5E62c1C592b7CdB";
// export const DONATION_FUND_TOKEN_ADDRESS = "0x915D291d182009Ea6f427f2B35BAd718F9a4955d";
// export const GIVING_FUND_ADDRESS = "0xEA9D78Bdae80e080CEad2E898e2919Ad26d213E3";

export const GIFT_TOKEN_ADDRESS = "0x6783267d5e3C50EC7CDE9aC41648ead7B5bbEd03";

export const PINATA_API_KEY = "7ada3533ce547fe77ce0";
export const PINATA_SECRET_API_KEY = "460025e87cfcce865e592d3da800b3080f3d8a47f90b3bc5934c7bb5817e824f";
export const MORALIS_SERVERURL = "https://nmmzadk7wdvn.usemoralis.com:2053/server";
export const MORALIS_APPID = "MeolQZfuT5hYwoYQKtxrV7JDBDQmnsXKgYZPz81Y";

export const UNSTOPPABLEDOMAINS_CLIENT_ID = "pUPArvXK4EhJEMnfgBhMG0gK5S8jw3OPg7tRUw05LbY=";
export const UNSTOPPABLEDOMAINS_CLIENT_SECRET = "zsI7LTU5dYo8Jexe6PCe9UYD/jtdk17hA31GJOhG2mA=";
export const UNSTOPPABLEDOMAINS_REDIRECT_URI = "https://stakeshares.netlify.app/callback";
export const UNSTOPPABLEDOMAINS_LOGOUT_REDIRECT_URI = "https://stakeshares.netlify.app/";